import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutConfig} from '@spartacus/storefront';
import {ConfigModule} from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: {
          min: 1200,
        },
      },
      layoutSlots: {
        header: {
          lg: {
            slots: [
              'SiteLinks',
            ],
          },
          slots: [
            'SiteLinks',
          ],
        },
        headBand: {
          slots: ['HeadBandContentSlot'],
        },
        rightPart: {
          slots: ['SearchBox', 'SiteLogin', 'MiniCart'
          ]
        },
        navigation: {
          lg: {
            slots: ['PreHeader', 'SiteLogo',
              'NavigationBar'],
          },
          slots: ['PreHeader', 'SiteLogo',
            'NavigationBar'],
        },
        ProductListPageTemplate: {
          slots: ['TopHeaderSlot', 'ProductLeftRefinements', 'ProductListSlot'],
        },
        ProductGridPageTemplate: {
          slots: ['TopHeaderSlot', 'ProductLeftRefinements', 'ProductListSlot'],
        },
        LandingPage2Template: {
          md: {
            pageFold: 'SiteLogo'
          },
          slots: [
            'Section1',
            'Section2',
            'Section3',
            'Section4',
            'Section5',
            'Section6',
            'Section7',
            'Section8',
            'Section9',
            'Section10'
          ],
        },
        BackgroundGreenPageTemplate: {
          slots: [
            'SideContent',
            'LeftContentSlot',
            'RightContentSlot',
            'BodyContent',
          ],
          header: {
            slots: [],
          },
          headBand: {
            slots: [],
          },
          rightPart: {
            slots: []
          },
          navigation: {
            slots: ['SiteLogo'],
          },
          footer: {
            slots: []
          }
        },
        MultiStepCheckoutSummaryPageTemplate: {
          header: {
            slots: [],
          },
          headBand: {
            slots: [],
          },
          rightPart: {
            slots: []
          },
          navigation: {
            slots: ['SiteLogo'],
          },
          footer: {
            slots: []
          }
        },
        LandingPage3Template: {
          md: {
            pageFold: 'SiteLogo'
          },
          slots: [
            'Section1',
            'Section2',
            'Section3',
            'Section4',
            'Section5',
            'Section6',
            'Section7',
            'Section8',
            'Section9',
            'Section10'
          ],
        },
        LandingPage4Template: {
          slots: [
            'Section1',
            'CategoryFamiliesContentSlot'
          ],
        },
        FormsPageTemplate: {
          slots: [
            'BottomHeaderFormSlot',
            'Section1'
          ],
        },
        OutletLandingPageTemplate: {
          md: {
            pageFold: 'SiteLogo'
          },
          slots: [
            'Section1',
            'Section2',
            'Section3',
            'Section4',
            'Section5',
            'Section6',
            'Section7',
            'Section8',
            'Section9',
            'Section10'
          ],
        },
        PolicyPageTemplate: {
          slots: [
            'LeftMenuSlot',
            'Section1'
          ]
        },
        StoreFinderPageTemplate: {
          slots: [
            'MiddleContent',
            'Section1'
          ]
        },
        AccountPageTemplate: {
          slots: [
            'LeftMenuSlot',
            'BodyContent'
          ]
        },
        CartPageTemplate: {
          slots: ['TopContent',
            'CenterRightContentSlot',
            'EmptyCartMiddleContent',
            'BottomContentSlot'
          ],
        },
        ThankYouPageTemplate: {
          slots: [
            'SideContent',
            'BodyContent'
          ],
        }
      },
    } as LayoutConfig)
  ],
})
export class CustomLayoutModule {
}
